// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pa-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
}

.pa-header h2 {
  font-size: 26px;
  font-weight: bold;
  color: #222;
}

.pa-btn-add {
  background: #222e3c;
  color: #fff;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 15px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s;
}
.pa-btn-add:hover { background: #1a2230; }

.pa-loading,
.pa-empty {
  text-align: center;
  color: #888;
  margin-top: 60px;
  font-size: 16px;
}

.pa-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
}

.pa-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.pa-card-img {
  width: 100%;
  height: 160px;
  background: #f0f4f8;
  overflow: hidden;
}

.pa-card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pa-card-no-img {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bbb;
  font-size: 14px;
}

.pa-card-body {
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
}

.pa-card-category {
  font-size: 11px;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
}

.pa-card-name {
  font-size: 15px;
  font-weight: 600;
  color: #222;
  line-height: 1.3;
}

.pa-card-price {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.pa-price-current {
  font-size: 16px;
  font-weight: 700;
  color: #222e3c;
}

.pa-price-original {
  font-size: 13px;
  color: #aaa;
  text-decoration: line-through;
}

.pa-card-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.pa-btn-edit,
.pa-btn-delete {
  flex: 1 1;
  padding: 9px 0;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.pa-btn-edit {
  background: #e8f0fe;
  color: #1a56db;
}
.pa-btn-edit:hover { background: #d1e0fd; }

.pa-btn-delete {
  background: #fde8e8;
  color: #c81e1e;
}
.pa-btn-delete:hover { background: #fbd5d5; }
.pa-btn-delete:disabled { opacity: 0.6; cursor: not-allowed; }
`, "",{"version":3,"sources":["webpack://./src/pages/ProductsAdmin.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA,oBAAoB,mBAAmB,EAAE;;AAEzC;;EAEE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,SAAO;EACP,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,qBAAqB,mBAAmB,EAAE;;AAE1C;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,0BAA0B,YAAY,EAAE,mBAAmB,EAAE","sourcesContent":[".pa-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 28px;\n}\n\n.pa-header h2 {\n  font-size: 26px;\n  font-weight: bold;\n  color: #222;\n}\n\n.pa-btn-add {\n  background: #222e3c;\n  color: #fff;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 15px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: background 0.2s;\n}\n.pa-btn-add:hover { background: #1a2230; }\n\n.pa-loading,\n.pa-empty {\n  text-align: center;\n  color: #888;\n  margin-top: 60px;\n  font-size: 16px;\n}\n\n.pa-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 20px;\n}\n\n.pa-card {\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.08);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.pa-card-img {\n  width: 100%;\n  height: 160px;\n  background: #f0f4f8;\n  overflow: hidden;\n}\n\n.pa-card-img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.pa-card-no-img {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #bbb;\n  font-size: 14px;\n}\n\n.pa-card-body {\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n}\n\n.pa-card-category {\n  font-size: 11px;\n  text-transform: uppercase;\n  color: #888;\n  letter-spacing: 0.5px;\n}\n\n.pa-card-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: #222;\n  line-height: 1.3;\n}\n\n.pa-card-price {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.pa-price-current {\n  font-size: 16px;\n  font-weight: 700;\n  color: #222e3c;\n}\n\n.pa-price-original {\n  font-size: 13px;\n  color: #aaa;\n  text-decoration: line-through;\n}\n\n.pa-card-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.pa-btn-edit,\n.pa-btn-delete {\n  flex: 1;\n  padding: 9px 0;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.pa-btn-edit {\n  background: #e8f0fe;\n  color: #1a56db;\n}\n.pa-btn-edit:hover { background: #d1e0fd; }\n\n.pa-btn-delete {\n  background: #fde8e8;\n  color: #c81e1e;\n}\n.pa-btn-delete:hover { background: #fbd5d5; }\n.pa-btn-delete:disabled { opacity: 0.6; cursor: not-allowed; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
